import css from "./index.css";

export default {
    view() {
        return m("i", { class : css.errIcon });
    }
};
